export { default } from "./CultureInfoTipContainer";
